import React, { useState, useEffect } from 'react';
import HamburgerNav from './HamburgerNav';
import ContactForm from './ContactForm';
import './BackThePass.css';

const BackThePass = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [showOrgOptions, setShowOrgOptions] = useState(false);
  const [selectedOrgOption, setSelectedOrgOption] = useState(null);
  const [defaultPartnershipType, setDefaultPartnershipType] = useState('');

  useEffect(() => {
    // Reset org options when modal closes
    if (activeModal !== 'organizations') {
      setShowOrgOptions(false);
      setSelectedOrgOption(null);
    }
  }, [activeModal]);

  const handleModalClick = (type) => {
    if (type === 'organizations') {
      setActiveModal(type);
      // Small delay for smooth transition
      setTimeout(() => setShowOrgOptions(true), 100);
    } else {
      setActiveModal(type);
    }
  };

  const handleOrgOptionClick = (option) => {
    if (window.innerWidth <= 768) {
      // On mobile, show the selected option's details
      setSelectedOrgOption(option);
    } else {
      // On desktop, go straight to contact form if applicable
      if (option === 'lodging' || option === 'investment' || option === 'other') {
        openContactForm(option);
      }
    }
  };

  const closeModal = () => {
    setActiveModal(null);
    setShowOrgOptions(false);
    setSelectedOrgOption(null);
    setDefaultPartnershipType('');
  };

  const openContactForm = (type) => {
    setDefaultPartnershipType(type);
    setActiveModal('contact');
  };

  const renderOrgOptionContent = (option) => {
    switch(option) {
      case 'lodging':
        return (
          <>
            <h3>Getting Your Hostel on a BackPass Route</h3>
            <p>We don't seek wholesale or discount. If you are a fit, we only require a contact and your preferred payment method.</p>
            <button 
              className="org-action-button"
              onClick={() => openContactForm('lodging')}
            >
              Start Here
            </button>
          </>
        );
      case 'investment':
        return (
          <>
            <h3>Growth at Scale</h3>
            <p>Currently seeking silent partners and industry experts. Learn more about our vision, board, and current stack.</p>
            <button 
              className="org-action-button"
              onClick={() => openContactForm('investment')}
            >
              Start Here
            </button>
          </>
        );
      case 'other':
        return (
          <>
            <h3>Other Inquiries</h3>
            <p>BackPass is always considering novel verticals. Let us know what you have in mind.</p>
            <button 
              className="org-action-button"
              onClick={() => openContactForm('other')}
            >
              Start Here
            </button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="back-the-pass-container">
      {/* Hero Section */}
      <section 
        className="hero-section"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url('/images/archedbackground.webp') center/cover`
        }}
      >
        <HamburgerNav animationDelay="0.4s" />
        
        <div className="hero-content">
          <a href="/" className="hero-logo">
            <img src="/images/logodownsized.webp" alt="BackPass Logo" className="logo" />
          </a>
          <h1 className="hero-title-caveat">Back the Pass</h1>
          <p className="hero-subtitle">Learn More About Partnership Opportunities Below</p>
          
          {/* CTA Buttons */}
          <div className="cta-buttons">
            <button
              className="cta-button"
              onClick={() => window.location.href = '/creators'}
            >
              For Travelers
            </button>
            <button
              className="cta-button"
              onClick={() => handleModalClick('organizations')}
            >
              For Organizations
            </button>
          </div>
        </div>
      </section>

      {/* Modal Overlays */}
      {activeModal && (
        <div className="modal-overlay" onClick={closeModal}>
          {/* Organizations Options - No outer container */}
          {activeModal === 'organizations' && !selectedOrgOption && (
            <>
              {/* Desktop Version */}
              <div className={`org-options-wrapper desktop ${showOrgOptions ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
                <div 
                  className="org-option" 
                  onClick={() => handleOrgOptionClick('lodging')}
                >
                  {renderOrgOptionContent('lodging')}
                </div>
                
                <div 
                  className="org-option"
                  onClick={() => handleOrgOptionClick('investment')}
                >
                  {renderOrgOptionContent('investment')}
                </div>
                
                <div 
                  className="org-option" 
                  onClick={() => handleOrgOptionClick('other')}
                >
                  {renderOrgOptionContent('other')}
                </div>
              </div>

              {/* Mobile Version */}
              <div className={`org-options-wrapper mobile ${showOrgOptions ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
                <div 
                  className="org-option-mobile" 
                  onClick={() => handleOrgOptionClick('lodging')}
                >
                  <h3>BackPass Route Partnerships</h3>
                </div>
                
                <div 
                  className="org-option-mobile"
                  onClick={() => handleOrgOptionClick('investment')}
                >
                  <h3>Participating in Our Next Raise</h3>
                </div>
                
                <div 
                  className="org-option-mobile" 
                  onClick={() => handleOrgOptionClick('other')}
                >
                  <h3>Brand Partnership/Other Inquiries</h3>
                </div>
              </div>
            </>
          )}

          {/* Selected Organization Option - Mobile Only */}
          {selectedOrgOption && (
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="org-detail-view">
                {renderOrgOptionContent(selectedOrgOption)}
              </div>
            </div>
          )}

          {/* Contact Form Modal */}
          {activeModal === 'contact' && (
            <div className="modal-content contact-form-modal" onClick={(e) => e.stopPropagation()}>
              <ContactForm 
                onClose={closeModal}
                showPartnershipType={true}
                defaultPartnershipType={defaultPartnershipType}
                formTitle="Get in Touch For Next Steps"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BackThePass;